import { ACTION_TYPES } from '../../utils/Constants';
let intialState = {
    usersList: [],
};

const UserReducer = (state = intialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.INS_SUPER_ADMIN.EDUPARENT_LIST:
            state = {
                ...state,
                usersList: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};
export default UserReducer;
